<template>
    <div>
        <m-assembly-table ref='pageForm'
            :formData='formData'
            :columns='columns'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange="onSelectionChange"
        >
        </m-assembly-table>

        <!--物料编码-->
        <Modal
            :title="$t('gscInvoice.t50')"
            v-model="itemCodeModal.show"
            :width="600"
            :mask-closable="false">
            <Form
                ref="itemCodeFormRef"
                :model="itemCodeModal.form"
                :label-width="100">
                <Row>
                    <Col :span="9">
                        <FormItem :label="$t('gscInvoice.t50')">
                            <Input
                                size="small"
                                v-model.trim="itemCodeModal.form.itemCode">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col :span="9">
                        <FormItem :label="$t('gscInvoice.t51')">
                            <Input
                                size="small"
                                v-model.trim="itemCodeModal.form.itemDesc">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col :span="1">
                        &nbsp;
                    </Col>
                    <Col :span="5">
                        <Button type="primary" :loading="itemCodeModal.loading" @click="getItemList">{{$t('page.query.search')}}</Button>
                    </Col>
                </Row>
            </Form>
            <Table
                v-if="itemCodeModal.show"
                ref="itemCodeTableRef"
                size="small"
                thDrag
                highlight-row
                border
                :loading="itemCodeModal.loading"
                :columns="itemCodeModal.columns"
                :data="itemCodeModal.tableData"
                @on-row-click="itemCodeRowClick">
            </Table>
            <Page
                :total="itemCodeModal.total"
                show-elevator
                show-total
                size="small"
                transfer
                @on-change="itemCodeOnPageChange"
                placement="top" />
            <template slot="footer">
                <Button type="primary" :disabled="!itemCodeModal.row" @click="itemCodeOnConfirm">{{$t('common.confirmBtn')}}</Button>
            </template>
        </Modal>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import { langParams, exportExcel } from '@/utils/tool';
import axios from 'axios';
import moment from 'moment';
import mixin from './index';

export default {
    name: 'commercialInvoice',
    components: {
        mAssemblyTable,
    },
    mixins: [mixin],
    computed: {
        getFormVals() {
            return this.getFormDataVModel(this.formData.items);
        },
        idList() {
            return this.selection.map((item) => item.headerId);
        },
    },
    data() {
        return {
            formData: {
                row: 3,
                items: [
                    {
                        value: '',
                        field: 'organizationCode', // 库存组织
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        methods: {
                            change: () => {
                                this.tableData = [];
                                this.selection = [];
                                this.settings.total = 0;
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('createDeliveryOrderByOrder.t1'),
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require'),
                            },
                        },
                    },
                    {
                        value: '',
                        field: 'invoiceNumber', // 发票号码
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('commercialInvoice.t1'),
                    },
                    {
                        value: '',
                        field: 'invoiceDateBegin', // 发票日期
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('importNoticeCommon.t45'),
                        placeholder: '',
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'invoiceDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {
                                },
                            },
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                    },
                    {
                        value: '',
                        field: 'currency', // 币种
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('gscInvoice.t17'),
                    },
                    {
                        value: '',
                        field: 'vendorStatus', // 状态
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('gscInvoice.t62'),
                    },
                    {
                        value: '',
                        field: 'creationDateBegin', // 创建日期
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('InOutBillMgnView.startEndCrtDate'),
                        placeholder: '',
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'creationDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {
                                },
                            },
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                    },
                    {
                        value: '',
                        field: 'headerNum',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('typeTestProcessSearch.t7'), // 单据号
                    },
                    {
                        value: '',
                        field: 'cont', // 实体柜号
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('commercialInvoice.t2'), // 实体柜号
                    },
                    {
                        value: '',
                        field: 'ctn', // 箱号
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t56'),
                    },
                    {
                        value: '',
                        field: 'itemCode', // 物料编码
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('gscInvoice.t50'),
                        icon: 'search',
                        canClick: true,
                        click: () => {
                            if (this.$refs.pageForm.validateForm()) {
                                Object.assign(this.itemCodeModal, {
                                    show: true,
                                    type: 'form',
                                });
                            }
                        },
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        key: 'organizationCode',
                        minWidth: 80,
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t7'), // 单据号
                        key: 'headerNum',
                        minWidth: 120,
                        align: 'center',
                        render: (h, params) => {
                            const { headerId, headerNum } = params.row;
                            return h('a', {
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'commercialInvoiceDetail',
                                            query: {
                                                headerId,
                                            },
                                        });
                                    },
                                },
                            }, headerNum);
                        },
                    },
                    {
                        title: this.$t('gscInvoice.t62'), // 状态
                        key: 'vendorStatus',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('span', this.INT_COMMERCIAL_INVOICE_STATUS.find((item) => item.value === params.row.vendorStatus)?.label);
                        },
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t57'), // 发票号
                        key: 'invoiceNumber',
                        minWidth: 200,
                        tooltip: true,
                    },
                    // {
                    //     title: this.$t('commercialInvoice.t3'), // 实际柜号
                    //     key: 'cont',
                    //     minWidth: 100,
                    //     align: 'center',
                    // },
                    // {
                    //     title: this.$t('DeliveryOrderQuery.t56'), // 箱号
                    //     key: 'ctn',
                    //     minWidth: 100,
                    //     align: 'center',
                    // },
                    // {
                    //     title: this.$t('gscInvoice.t50'), // 物料编码
                    //     key: 'itemCode',
                    //     minWidth: 100,
                    //     align: 'center',
                    // },
                    // {
                    //     title: this.$t('gscInvoice.t51'), // 物料描述
                    //     key: 'itemName',
                    //     minWidth: 150,
                    //     tooltip: true,
                    // },
                    // {
                    //     title: this.$t('importNoticeCommon.t119'), // 品牌
                    //     key: 'brand',
                    //     minWidth: 100,
                    //     align: 'center',
                    // },
                    // {
                    //     title: this.$t('commercialInvoice.t4'), // 原产国
                    //     key: 'origin',
                    //     minWidth: 100,
                    //     align: 'center',
                    // },
                    // {
                    //     title: this.$t('QueryStoreToolView.storeCount'), // 数量
                    //     key: 'singQty',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    // {
                    //     title: this.$t('commercialInvoice.t5'), // 净重
                    //     key: 'netWeight',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    // {
                    //     title: this.$t('importNoticeCommon.t163'), // 毛重
                    //     key: 'grossWeight',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    // // {
                    // //     title: this.$t('commercialInvoice.t6'), // 钢价
                    // //     key: '',
                    // //     minWidth: 60,
                    // //     align: 'right',
                    // // },
                    // {
                    //     title: this.$t('commercialInvoice.t7'), // 铜价
                    //     key: 'copperPrice',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    // {
                    //     title: this.$t('commercialInvoice.t8'), // 加工费
                    //     key: 'fabricationFee',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    // {
                    //     title: this.$t('commercialInvoice.t9'), // 单价合计
                    //     key: '',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    // {
                    //     title: this.$t('gscInvoice.t55'), // 金额
                    //     key: 'price',
                    //     minWidth: 60,
                    //     align: 'right',
                    // },
                    {
                        title: this.$t('gscInvoice.t103'), // 发票金额
                        key: 'invoiceAmount',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('commercialInvoice.t10'), // 发票数量
                        key: 'invoiceQty',
                        minWidth: 80,
                        align: 'right',
                    },
                    {
                        title: this.$t('importNoticeCommon.t45'), // 发票日期
                        key: 'invoiceDate',
                        minWidth: 100,
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t28'), // 创建人
                        key: 'createdBy',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('UIDLabelPrint.t32'), // 创建日期
                        key: 'creationDate',
                        minWidth: 100,
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('commercialInvoice.t11'), // 最后更新日期
                        key: 'lastUpdateDate',
                        minWidth: 100,
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t33'), // 拒绝原因
                        key: 'rejectReason',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('common.operation'), // 操作
                        key: 'opt',
                        align: 'center',
                        minWidth: 90,
                        fixed: 'right',
                        render: (h, params) => {
                            const { vendorStatus, headerId } = params.row;
                            const isEdit = ['PRICING_REJECT', 'VENDOR_DRAFT'].includes(vendorStatus);
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                name: isEdit ? 'commercialInvoiceEdit' : 'commercialInvoiceDetail',
                                                query: {
                                                    headerId,
                                                },
                                            });
                                        },
                                    },
                                }, this.$t(isEdit ? 'importNoticeCommon.t12' : 'importNoticeCommon.t15')), // 修改、查看
                            ]);
                        },
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('common.newBtn'), // 新增
                        type: 'primary',
                        icon: 'archive',
                        size: 'small',
                        click: (button) => {
                            setTimeout(() => {
                                this.$router.push({
                                    name: 'commercialInvoiceAdd',
                                });
                            });
                        },
                    },
                    {
                        label: this.$t('common.delBtn'), // 删除
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        size: 'small',
                        click: (button) => {
                            this.$Modal.confirm({
                                content: this.$t('gscInvoice.t107'), // 确定要删除吗？
                                onOk: () => {
                                    button.loading = true;
                                    setTimeout(() => {
                                        this.deleteHeader()
                                            .finally(() => {
                                                button.loading = false;
                                            });
                                    }, 400);
                                },
                            });
                        },
                    },
                    {
                        label: this.$t('importNoticeCommon.t13'), // 作废
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        size: 'small',
                        click: (button) => {
                            this.$Modal.confirm({
                                content: this.$t('importNoticeCommon.t23'), // 确定要作废吗？
                                onOk: () => {
                                    button.loading = true;
                                    setTimeout(() => {
                                        this.discard()
                                            .finally(() => {
                                                button.loading = false;
                                            });
                                    }, 400);
                                },
                            });
                        },
                    },
                    {
                        label: this.$t('common.export'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.validateForm()) {
                                this.$set(button, 'loading', true);
                                exportExcel('/gscint/cgzxInvoice/exportHeader', {
                                    ...this.getFormVals,
                                    vendorCode: this.vendorCode,
                                    language: langParams(this.$i18n.locale),
                                }, `${this.$t('route.commercialInvoice')}${moment().format('YYYY-MM-DD')}.xlsx`, this)
                                    .finally(() => {
                                        this.$set(button, 'loading', false);
                                    });
                            }
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false,
            },
            selection: [],
        };
    },
    methods: {
        onSubmit() {
            this.loading = true;
            const { currentPage, pageSize } = this.settings;
            axios.post('/gscint/cgzxInvoice/queryHeaderPage', {
                ...this.getFormVals,
                vendorCode: this.vendorCode,
                pageIndex: currentPage,
                pageSize,
                language: langParams(this.$i18n.locale),
            })
                .then(res => {
                    const { code, data, msg: content } = res.data.data;
                    if (code == 1) {
                        const { list, total } = data;
                        this.tableData = list;
                        this.settings.total = total;
                        this.selection = [];
                        // this.$nextTick(() => {
                        //     const { objData } = this.$refs.pageForm.$refs.iTable.$refs.iTable;
                        //     Object.keys(objData).forEach((key) => {
                        //         if (!['VENDOR_DRAFT', 'PRICING_REJECT'].includes(objData[key].vendorStatus)) {
                        //             objData[key]._isDisabled = true;
                        //         }
                        //     });
                        // });
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        deleteDiscardApi(url, key) {
            return axios.post(url, {
                idList: this.idList,
            })
                .then((res) => {
                    const { code, message: content } = res.data.data;
                    if (code == 1) {
                        this.$Modal.success({
                            content: this.$t(key),
                        });
                        this.onSubmit();
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                });
        },
        /* 删除 */
        deleteHeader() {
            return this.deleteDiscardApi('/gscint/cgzxInvoice/deleteHeader', 'common.delete_success'); // 删除成功
        },
        /* 作废 */
        discard() {
            return this.deleteDiscardApi('/gscint/cgzxInvoice/discard', 'commercialInvoice.t12'); // 作废成功
        },
    },
    mounted() {

    },
};
</script>
